module.exports = __webpack_public_path__ + "static/first.ebbedd73.png";